module.exports = __webpack_public_path__ + "static/media/About-bg3.fe6be0fe.jpg";